import React from 'react';

const Divider = ({ width = '100%', color = '#000' }) => {
  const dividerStyle = {
    margin: '0',
    height: '1px', 
    backgroundColor: color, 
    width: width,
  };

  return <div style={dividerStyle} />;
};

export default Divider;
